import { createContext, useEffect, useState } from "react";
import { useCookies } from "react-cookie";
import { getLoggedInUser, getUserCompany,  getReportData } from "../service/network";

const tokenCookieName = "outletace_token";
const roleCookieName = "outletace_role";
const RefreshTokenCookieName = "outletace_refresh_token";
const user_doc = "outletace_doc";

export const useAuthToken = () => {
    const [cookies, setCookie, removeCookie] = useCookies([tokenCookieName, roleCookieName]);
    const setToken = (value) => setCookie(tokenCookieName, value);
    const removeToken = () => removeCookie(tokenCookieName);
    const setRole = (value) => setCookie(roleCookieName, value);
    const removeRole = () => removeCookie(roleCookieName);
    return [
        cookies[tokenCookieName],
        setToken,
        removeToken,
        cookies[roleCookieName],
        setRole,
        removeRole,
    ];
};

function useLocalStorage(key, initialValue) {
    const [storedValue, setStoredValue] = useState(() => {
        try {
            const item = window.localStorage.getItem(key);
            return item ? JSON.parse(item) : initialValue;
        } catch (error) {
            console.log(error);
            return initialValue;
        }
    });

    const removeValue = (key) => {
        setStoredValue();
        window.localStorage.removeItem(key);
    };

    const setValue = (value) => {
        try {
            const valueToStore = value instanceof Function ? value(storedValue) : value;
            setStoredValue(valueToStore);
            window.localStorage.setItem(key, JSON.stringify(valueToStore));
        } catch (error) {
            console.log(error);
        }
    };

    return [storedValue, setValue, removeValue];
}

export const AuthContext = createContext({});

const AuthContProvider = (props) => {
    const [authToken, setAuthToken, removeAuthToken, setAuthRole, removeAuthRole] =
        useAuthToken();
    const [userDoc, setUserDoc] = useLocalStorage(user_doc, {});
    const [isAdmin, setisAdmin] = useState(false);
    // const [authenticated, setAuthenticated] = useState(true);
    const [authenticated, setAuthenticated] = useState(window.localStorage.getItem(user_doc) ? true : false);
    // console.log("docs",userDoc);
    const [company, setCompany] = useLocalStorage("user_company", null);
    const [locations, setLocations] = useState([]);
    const [selLocation, setselLocation] = useLocalStorage("sel_plant", ['']);

    const getAllLocations = async () => {
        let company = await getReportData({
            doctype: "Company",
            fields: ["name"]
        });
        setLocations(company.data.message.values);
        console.log((!selLocation), (!company.data.message.values.includes(selLocation)));
        if ((!selLocation)) {
            setselLocation(company.data.message.values[0]);
        }
        else if (selLocation) {
            let found = false;
            for (let cmp of company.data.message.values) {
                console.log(selLocation, cmp);
                if (JSON.stringify(selLocation) === JSON.stringify(cmp)) {
                    found = true;
                }
            }
            if (!found) {
                console.log("Not found");
                setselLocation(company.data.message.values[0]);
            }
        }
    }

    useEffect(() => {
        if (authenticated) {
            getAllLocations();
        }
    }, [authenticated]);

    const setRole = (role) => {
        setAuthRole(role);
        setisAdmin(false);
    };

    const setLogin = (token) => {
        setAuthenticated(true);
        window.localStorage.setItem("outletace_jwt", token);
        setAuthToken(token);
        // getAllLocations();
    };

    const setRefreshToken = (refreshToken) => {
        window.localStorage.setItem(RefreshTokenCookieName, refreshToken);
    }

    

    const logout = (token) => {
        setisAdmin(false);
        removeAuthRole();
        setAuthenticated(false);
        removeAuthToken();
        window.localStorage.clear();
    };

    const defaultContext = {
        authenticated,
        setLogin,
        setRole,
        setRefreshToken,
        logout,
        locations,
        selLocation,
        setselLocation,
        isAdmin,
        userDoc,
        setUserDoc,
        authToken,
        company
    };

    // eslint-disable-next-line react/prop-types
    return <AuthContext.Provider value={defaultContext}>{props.children}</AuthContext.Provider>;
};

export default AuthContProvider;
